<template>
    <div class="my-5 border-b border-t border-grey-light">
        <!-- Modal -->
        <div id="NewView" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">New Lists</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <input v-model="new_view" type="text" name="name" id="name"
                               class="rounded p-2 text-grey-darkest text-sm focus:outline-none border-1 w-full">
                        <div class="text-red text-xs">{{
                                showError
                            }}
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button  type="button" id="save-proposal-generator" name="save-proposal-generator"
                                 @click.prevent="saveNewView"
                                 class="btn btn-outline-primary rounded-full">
                            Save Lists
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap container bg-grey-lightest justify-between items-start shadow-md rounded">
            <div class="row w-full justify-end mt-2">
<!--                <button class="btn btn-primary mr-2" @click.prevent="openNewViewModel">Save Lists</button>-->
                <button class="btn btn-danger mr-2" @click.prevent="clear">Clear</button>
                <button class="btn btn-primary" @click.prevent="execute">Apply</button>
            </div>
            <div class="row flex w-full lg:w-1/2 mt-3 mt-lg-0">
                <h4 class="col-md-12 mb-3 border-b border-grey-teal pb-2">
                    Project Information
                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            ID
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" v-model="advanced_filter.project_id">
                        </div>
                    </div>

                    <div v-if="userLegacy" class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Legacy ID
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" v-model="advanced_filter.legacy_id">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Project Name
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" v-model="advanced_filter.project_name">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Address
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" v-model="advanced_filter.address">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            City
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" v-model="advanced_filter.city">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            State
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" v-model="advanced_filter.state">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Zip
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" v-model="advanced_filter.zip">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Name
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" v-model="advanced_filter.contact_name">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Email
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control" v-model="advanced_filter.contact_email">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Phone
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control"
                                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                   v-model="advanced_filter.contact_phone">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Cell
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control"
                                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                   v-model="advanced_filter.contact_cell">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contact Fax
                        </div>
                        <div class="col-md-12">
                            <input type="text" class="form-control"
                                   v-mask="['(###) ###-####', '(###) ###-#### ext. #####']"
                                   v-model="advanced_filter.contact_fax">
                        </div>
                    </div>
                </div>
            </div>
            <div class="row flex w-full w-full lg:w-1/2 mt-3 mt-lg-0">
                <h4 class="col-md-12 mb-3 border-b border-grey-light pb-2">
                    Miscellaneous Information
                </h4>
                <div class="pt-4 pb-2 px-3">
                    <div class="flex flex-wrap">
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Project Stage
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.project_stages"
                                             id="project_stage_id"
                                             placeholder="Project Stage"
                                             :options="selects.project_stages"
                                             :multiple="true"
                                             trackBy="id"
                                             label="full_description"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Project Duration
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.project_durations"
                                             id="project_duration_id"
                                             placeholder="Project Duration"
                                             :options="selects.project_durations"
                                             :multiple="true"
                                             trackBy="id"
                                             label="full_description"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Est. Complete Date
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.complete_date.start" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.complete_date.end" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Actual Completed Date
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.actual_completed_date.start" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.actual_completed_date.end" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Login Date
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.login_date.start" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.login_date.end" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Project Start Date
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.production_start_date.start" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.production_start_date.end" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Project End Date
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.production_end_date.start" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.production_end_date.end" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Project Manager
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.project_managers"
                                             id="project_manager_id"
                                             placeholder="Project Manager"
                                             :options="selects.pm_users"
                                             :multiple="true"
                                             trackBy="id"
                                             label="name"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Project Engineer
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.project_engineers"
                                             id="project_engineer_id"
                                             placeholder="Project Engineer"
                                             :options="selects.pm_users"
                                             :multiple="true"
                                             trackBy="id"
                                             label="name"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Project Admin
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.project_admins"
                                             id="project_admin_id"
                                             placeholder="Project Admin"
                                             :options="selects.pm_users"
                                             :multiple="true"
                                             trackBy="id"
                                             label="name"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Superintendent
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.superintendents"
                                             id="superintendent_id"
                                             placeholder="Superintendent"
                                             :options="selects.pm_users"
                                             :multiple="true"
                                             trackBy="id"
                                             label="name"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Crew Leader
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.crew_leaders"
                                             id="crew_leader_id"
                                             placeholder="Crew Leader"
                                             :options="selects.pm_users"
                                             :multiple="true"
                                             trackBy="id"
                                             label="name"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                CL Start Date
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.crew_leader_start_date.start" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.crew_leader_start_date.end" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                CL End Date
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.crew_leader_end_date.start" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                    <div class="col-6">
                                        <datepicker v-model="advanced_filter.crew_leader_end_date.end" format="MM/dd/yyyy"
                                                    input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                        </datepicker>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Products & Services
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.products_and_services"
                                             id="products_and_services_id"
                                             placeholder="Products & Services"
                                             :options="selects.products_and_services"
                                             :multiple="true"
                                             trackBy="id"
                                             label="full_description"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Client Profile
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.client_profiles"
                                             id="client_profile_id"
                                             placeholder="Client Profile"
                                             :options="selects.client_profile"
                                             :multiple="true"
                                             trackBy="id"
                                             label="full_description"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Contract Type
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.contract_types"
                                             id="contract_type_id"
                                             placeholder="Contract Type"
                                             :options="selects.contract_type"
                                             :multiple="true"
                                             trackBy="id"
                                             label="full_description"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div class="form-group w-full md:w-1/2">
                            <div class="col-md-12 text-md">
                                Office
                            </div>
                            <div class="col-md-12">
                                <multiselect v-model="advanced_filter.offices"
                                             id="office_id"
                                             placeholder="Office"
                                             :options="selects.office"
                                             :multiple="true"
                                             trackBy="id"
                                             label="full_description"
                                             :taggable="false"
                                             :close-on-select="false"
                                >
                                </multiselect>
                            </div>
                        </div>
                    </div>
                </div>
                <advanced-search-custom-fields ref="customFields"
                                               :local-storage-values="customFieldsLocalStorage"
                                               :project-custom-fields="this.projectCustomFields" :masks="masks"></advanced-search-custom-fields>

            </div>
            <div class="row flex w-full lg:w-1/2 mt-3 mt-lg-0 mb-4">
                <h4 class="col-md-12 mb-3 border-b border-grey-light pb-2">
                    Cost Record Details
                </h4>
                <div class="col-md-12 flex flex-wrap">

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contract Amount
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.contract_amount" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Contract Date
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.contract_date.start" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                    </datepicker>
                                </div>
                                <div class="col-6">
                                    <datepicker v-model="advanced_filter.contract_date.end" format="MM/dd/yyyy"
                                                input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey">
                                    </datepicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            New Contract Amt
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.new_contract_amount" min="0"
                                   step="0.01">
                        </div>
                    </div>
                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Est. Gross Margin %
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.gross_margin" min="0"
                                   step="0.01">
                        </div>
                    </div>
                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Est. Gross Margin $
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.gross_margin_price" min="0"
                                   step="0.01">
                        </div>
                    </div>

                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Est. Labor Hours
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.labor_hours" min="0"
                                   step="0.01">
                        </div>
                    </div>
                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Act. Gross Margin %
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.act_gross_margin" min="0"
                                   step="0.01">
                        </div>
                    </div>
<div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Act. Gross Margin $
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.act_gross_margin_price" min="0"
                                   step="0.01">
                        </div>
                    </div>
                    <div class="form-group w-full md:w-1/2">
                        <div class="col-md-12 text-md">
                            Act. Labor Hours
                        </div>
                        <div class="col-md-12">
                            <input type="number" class="form-control" v-model="advanced_filter.act_labor_hours" min="0"
                                   step="0.01">
                        </div>
                    </div>
                </div>
            </div>

            <div class="row flex w-full lg:w-1/2 mt-3 mt-lg-0 mb-4">
                <h4 class="col-md-12 mb-3 border-b border-grey-teal pb-2">
                    Companies & Contacts
                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full">
                        <div class="col-md-12 text-md">
                            Companies
                        </div>
                        <div class="col-md-12">
                            <multiselect
                                v-model="advanced_filter.companies_id"
                                :options="companies"
                                label="name"
                                :multiple="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                @search-change="asyncFind"
                                :loading="isLoading"
                                track-by="id"
                                @input="selectedCompanies"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full">
                        <div class="col-md-12 text-md">
                            Contacts
                            <span v-if="contacts_data_loading" class="text-1xl text-grey-darkest text-center mt-32 ml-1">
                                <i class="fa fa-spin fa-spinner" aria-hidden="true"></i>
                            </span>
                        </div>
                        <div class="col-md-12">
                            <multiselect
                                v-model="advanced_filter.contact_ids"
                                :options="contacts"
                                label="name"
                                :multiple="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                track-by="id"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row flex w-full lg:w-1/2 mt-3 mt-lg-0">
                <h4 class="col-md-12 mb-3 border-b border-grey-teal pb-2">
                    Comments
                </h4>
                <div class="col-md-12 flex flex-wrap">
                    <div class="form-group w-full">
                        <div class="col-md-12 text-md">
                            Comments
                        </div>
                        <div class="col-md-12">
                            <b-form-textarea
                                id="textarea"
                                v-model="advanced_filter.comment"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Datepicker,
        Multiselect
    },
    props: ['userLegacy', 'advancedSearchViewFilterProjectData', 'advancedSearchViewFilterProjectCustomFields','masks', 'selects','fieldLabels'],
    watch: {
        advancedSearchViewFilterProjectData: function(newVal, oldVal) {
            this.advanced_filter = newVal;
        },
        advancedSearchViewFilterProjectCustomFields: function(newVal, oldVal) {
            this.projectCustomFields = newVal;
        },
        // selects: function(val){
        //     console.log("watcher for selects", val)
        //     this.fetchCompanies();
        // }
    },
    data() {
        return {
            isLoading: false,
            advanced_filter: {
                advanced: true,
                project_id: '',
                legacy_id: '',
                project_name: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                contact_name: '',
                contact_email: '',
                contact_phone: '',
                contact_cell: '',
                contact_fax: '',
                project_duration_id: 0,
                complete_date: {start: '', end: ''},
                actual_completed_date: {start: '', end: ''},
                production_start_date: {start: '', end: ''},
                production_end_date: {start: '', end: ''},
                crew_leader_start_date: {start: '', end: ''},
                crew_leader_end_date: {start: '', end: ''},
                project_admin_id: 0,
                project_engineer_id: 0,
                project_manager_id: 0,
                superintendent_id: 0,
                products_and_services_id: 0,
                client_profile_id: 0,
                contract_type_id: 0,
                office_id: 0,
                crew_leader_id: 0,
                contract_amount: '',
                new_contract_amount: '',
                contract_date: {start: '', end: ''},
                gross_margin: '',
                labor_hours: '',
                gross_margin_price: '',
                act_gross_margin: '',
                act_labor_hours: '',
                act_gross_margin_price: '',
                login_date: {start: '', end: ''},
                companies_id: [],
                contact_ids: [],
                comment: '',
                project_durations: null,
                project_stages: null,
                project_managers: null,
                project_engineers: null,
                project_admins: null,
                superintendents: null,
                crew_leaders: null,
                products_and_services: null,
                client_profiles: null,
                contract_types: null,
                offices: null,
            },
            customFieldsLocalStorage: null,
            companies: [],
            contacts: [],
            companiesSelected: [],
            new_view:'',
            showError:'',
            projectCustomFields: {},
            contacts_data_loading: false,
        }
    },

    created() {
        // this.fetchCodes();
        this.fetchCompanies();
    },

    methods: {
        execute() {
            const customFields = this.$refs.customFields.getFields();
            localStorage.setItem('last_search', JSON.stringify({...this.advanced_filter, custom_fields: customFields}));
            this.$emit('execute', {...this.advanced_filter, custom_fields: customFields});
        },

        fetchCodes() {
            axios.get(route('api.project.codes')).then(({data}) => {
                // for (var item in data) {
                //     if (Object.prototype.hasOwnProperty.call(data, item)) {
                //         data[item].unshift({id: 0, name: 'Select', code: 'Select', short_description: 'Select'})
                //     }
                // }
                // this.selects = data;
                this.selects.decision_process = data.decision_process ?? [];
                this.selects.find_problems = data.find_problems ?? [];
                this.selects.money_step = data.money_step ?? [];
                this.selects.pm_users = data.pm_users ?? [];
                this.selects.relate_and_connect = data.relate_and_connect ?? [];
                this.selects.rules_of_engagement = data.rules_of_engagement ?? [];
                this.selects.sales_status = data.sales_status.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.marketing_status = data.marketing_status.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.lead_from = data.lead_from.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.products_and_services = data.products_and_services.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.client_profile = data.client_profile.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.contract_type = data.contract_type.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.office = data.office.map(x => ( {id: x.id, short_description: x.short_description}));
                this.selects.users = data.users.map(x => ( {id: x.id, name: x.name}));
            });
        },
        fetchCompanies() {
            axios.get(route('api.company.list-for-report')).then(({data}) => {
                this.companies = data;
            });
        },

        // onSelectCompany(company) {
        //     this.advanced_filter.companies_id.push(company.id);
        // },
        // onRemoveCompany(company) {
        //     this.advanced_filter.companies_id = this.advanced_filter.companies_id.filter((aux) => aux !== company.id)
        // },
        //Client Filter
        asyncFind(querry) {
            this.isLoading = true
            axios.get(route('api.company.filter-for-report', {querry}
            )).then(({data}) => {
                this.companies = data;
                this.isLoading = false
            }).catch((error) => {
                this.isLoading = false
                console.log('error', error);
            });
        },
        clear() {
            localStorage.setItem('last_search', '');
            this.$refs.customFields.clearFields();
            this.customFieldsLocalStorage = null;

            for (var item in this.advanced_filter) {
                if (Object.prototype.hasOwnProperty.call(this.advanced_filter, item)) {
                    if (item == 'advanced') {
                        this.advanced_filter[item] = true;
                        continue;
                    }

                    if (item.includes('_id') && item != 'project_id' && item != 'companies_id' && item != 'contact_ids' && item != 'legacy_id') {
                        this.advanced_filter[item] = 0;
                        continue;
                    }

                    if (item.includes('date') || item == 'pre_bid') {
                        this.advanced_filter[item] = {start: '', end: ''};
                        continue;
                    }

                    this.advanced_filter[item] = '';
                }
            }
        },

        openNewViewModel() {
            $("#NewView").modal("show");
        },

        saveNewView() {
            if(this.new_view.replace(/\s/g, '') === ''){
                this.showError = 'Name field is required'
                return
            }
            this.showError = ''
            const customFields = this.$refs.customFields.getFields();
            localStorage.setItem('last_search', JSON.stringify({...this.advanced_filter, custom_fields: customFields}));
            this.$emit('saveNewView', {...this.advanced_filter, custom_fields: customFields, new_view:this.new_view});
            $('#NewView').modal('hide');
            this.new_view = '';
        },

        selectedCompanies() {
            const self = this;
            self.advanced_filter.contact_ids = [];
            self.contacts_data_loading = true;

            let selectedCompanies = self.advanced_filter.companies_id;
            let selectedCompanyIds = [];

            selectedCompanies.forEach(async (company) => {
                selectedCompanyIds.push(company.id);
            });

            if(selectedCompanyIds.length > 0) {
                axios.get(route('api.company.fetch-company-contacts', {company_ids: selectedCompanyIds})).then(({data}) => {
                    self.contacts = data;
                    self.contacts_data_loading = false;
                }).catch((error) => {
                    self.contacts_data_loading = false;
                    console.error('error', error);
                });
            } else {
                self.contacts_data_loading = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.form-control {
    height: calc(1em + .75rem + 2px);
    padding: 0;
}

.vdp-datepicker {
    .form-control:disabled,
    .form-control[readonly] {
        background-color: white !important;
    }
}

.form-control:disabled,
.form-control[readonly] {
    background-color: white !important;
}
</style>
